import axios from 'axios';
import { refreshToken, validateToken } from 'aws-auth-lib';

export const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json'
    }
});

export const setPanelRole = (uuid) => {
    if (uuid) {
        api.defaults.headers['CHEART-ROLE'] = uuid;
    } else {
        delete api.defaults.headers['CHEART-ROLE'];
    }
};

export const getPanelRole = () => {
    return api.defaults.headers['CHEART-ROLE'];
};

const updateToken = async (action) => {
    const token = await refreshToken();
    api.defaults.headers['AUTH-TOKEN-AWS'] = token;
    action.headers['AUTH-TOKEN-AWS'] = token;
    return action;
};

export const resolvePagination = (pageToken, pageLimit) => {
    const headers = {};
    if (pageToken) {
        headers['PAGINATION-TOKEN'] = pageToken;
    }
    if (pageLimit) {
        headers['PAGINATION-LIMIT'] = pageLimit;
    }
    return headers;
};

api.interceptors.request.use(
    async (config) => {
        if (
            !config.headers['AUTH-TOKEN-AWS'] ||
            !validateToken(config.headers['AUTH-TOKEN-AWS'])
        ) {
            config = await updateToken(config);
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// api.interceptors.response.use(
//     (response) => response,
//     async (error) => {
//         const originalRequest = error.config;
//         // eslint-disable-next-line no-underscore-dangle
//         if (error?.response.status === 401 && !originalRequest._retry) {
//             // eslint-disable-next-line no-underscore-dangle
//             originalRequest._retry = true;
//             try {
//                 const token = await refreshToken();
//                 api.defaults.headers.common['AUTH-TOKEN-AWS'] = token;
//                 originalRequest.headers['AUTH-TOKEN-AWS'] = token;
//                 // store the token in session attributes
//                 sessionStorage.setItem('token', JSON.stringify(token));
//             } catch (e) {
//                 console.log('axios get token', e);
//             }
//             return api(originalRequest);
//         }
//         return Promise.reject(error);
//     }
// );
